import React from 'react';
import { Navigate } from 'react-router-dom';
import tokenService from '../../services/tokenService';

interface RequireFeatureProps {
    feature: string;
    redirectTo: string;
    children: React.ReactNode;
}

export const RequireFeature: React.FC<RequireFeatureProps> = ({ feature, redirectTo, children }) => {
    if (!tokenService.hasFeature(feature)) {
        return <Navigate to={redirectTo} replace />;
    }
    return <>{children}</>;
};

export default RequireFeature;
